import React from "react";
import { Container, Typography, Box } from "@mui/material";

const AboutPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ fontWeight: 'bold' }}
        >
          About
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Learn more about Walkmore and our mission to help you track your fitness journey.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutPage;
